export default __webpack_public_path__ + "static/media/Inside XLD banner-02.e0d88e32.svg";